<template>
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon / Puzzle Checkmark</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.15881 12C10.2802 12 12 10.2802 12 8.15881C12 6.03738 10.2802 4.31763 8.15881 4.31763C6.03738 4.31763 4.31763 6.03738 4.31763 8.15881C4.31763 10.2802 6.03738 12 8.15881 12ZM6.27989 7.97466L7.34228 9.06958L10.0403 6.29157L10.3995 6.6618L7.34228 9.81266L5.91812 8.34488L6.27989 7.97466Z"
      :fill="iconColor"
    />
    <path
      d="M4.49854 0C5.4607 3.77852e-05 6.2407 0.780015 6.24072 1.74219C6.24072 1.77448 6.23972 1.80641 6.23779 1.83789H8.63379C8.83467 1.83791 8.99755 2.00077 8.99756 2.20166V4.59766C9.02904 4.59573 9.06097 4.59473 9.09326 4.59473C10.0554 4.59476 10.8354 5.37472 10.8354 6.33691C10.8354 6.34719 10.8347 6.35744 10.8345 6.36768C10.3316 5.66485 9.50919 5.20656 8.5791 5.20654C8.49052 5.20654 8.40286 5.21062 8.31641 5.21875C8.28683 5.16552 8.27003 5.10514 8.27002 5.04248V2.56543H5.79297C5.67486 2.56543 5.56378 2.50805 5.49561 2.41162C5.42751 2.31517 5.41029 2.19137 5.44971 2.08008C5.49029 1.96578 5.51317 1.85393 5.51318 1.74219C5.51316 1.18182 5.0589 0.727577 4.49854 0.727539C3.93825 0.727667 3.48439 1.18188 3.48438 1.74219C3.48439 1.85393 3.50727 1.96578 3.54785 2.08008C3.58724 2.19135 3.57004 2.31518 3.50195 2.41162C3.4338 2.50807 3.32269 2.5654 3.20459 2.56543H0.727539V4.63281C1.51501 4.80016 2.10596 5.49953 2.10596 6.33691C2.10582 7.17418 1.51493 7.87321 0.727539 8.04053V10.1079H2.79541C2.96274 9.32051 3.66125 8.7296 4.49854 8.72949C5.33594 8.72952 6.03535 9.32039 6.20264 10.1079H6.80469C7.2855 10.509 7.90402 10.7505 8.5791 10.7505C8.68278 10.7505 8.78502 10.744 8.88574 10.7329C8.82032 10.796 8.73187 10.8354 8.63379 10.8354H5.87695C5.67612 10.8354 5.51318 10.6725 5.51318 10.4717C5.51318 9.9113 5.05891 9.45707 4.49854 9.45703C3.93824 9.45716 3.48438 9.91135 3.48438 10.4717C3.48438 10.6725 3.32139 10.8353 3.12061 10.8354H0.36377C0.162867 10.8354 0 10.6726 0 10.4717V7.71484C9.04e-05 7.51402 0.162922 7.35107 0.36377 7.35107C0.924025 7.35101 1.37826 6.89715 1.37842 6.33691C1.37842 5.77655 0.92412 5.32233 0.36377 5.32227C0.16294 5.32227 0.000119206 5.1593 0 4.9585V2.20166C4.70765e-06 2.00076 0.16287 1.83789 0.36377 1.83789H2.75977C2.75784 1.80641 2.75684 1.77449 2.75684 1.74219C2.75686 0.780071 3.53644 0.0001284 4.49854 0Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'PuzzleCheckmark',
  props: {
    color: {
      type: String,
      default: '#343A3F',
    },
  },
  computed: {
    iconColor() {
      return this.color;
    },
  },
};
</script>
